import React from 'react';
import get from 'lodash/get';
import {ErrorMessage, FastField} from 'formik';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';
import Error from '../Error';
import PlusButton from './editor/PlusButton';
import MinusButton from './editor/MinusButton';

const SurveyParametersType = ({form, name, push, remove}) => {
    const values = get(form.values, name) || [];

    const addItem = React.useCallback(() => {
        push({name: '', mandatory: false, unique: false});
    }, [push]);

    if (values.length >0) {
        return (
            <table className="table table-sm table-borderless">
                <colgroup>
                    <col />
                    <col style={{width: 50}} />
                    <col style={{width: 50}} />
                    <col style={{width: 50}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className="pl-0"><FormattedMessage {...messages.surveys.form.label.parameters.name} /></th>
                        <th><FormattedMessage {...messages.surveys.form.label.parameters.mandatory} /></th>
                        <th><FormattedMessage {...messages.surveys.form.label.parameters.unique} /></th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {values.map((item, index) => (
                        <tr key={index}>
                            <td className="pl-0">
                                <FastField id={`${name}.${index}.name`} name={`${name}.${index}.name`} type="text" maxLength="30"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.${index}.name`) && get(form.touched, `${name}.${index}.name`)})} />
                                <ErrorMessage name={`${name}.${index}.name`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </td>
                            <td>
                                <FastField name={`${name}.${index}.mandatory`}>
                                    {({field}) => (
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" name={field.name} id={`${name}.${index}.mandatory`} className="custom-control-input"
                                                checked={field.value} onChange={field.onChange} />
                                            <label className="custom-control-label" htmlFor={`${name}.${index}.mandatory`}>&nbsp;</label>
                                        </div>
                                    )}
                                </FastField>
                            </td>
                            <td>
                                <FastField name={`${name}.${index}.unique`}>
                                    {({field}) => (
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" name={field.name} id={`${name}.${index}.unique`} className="custom-control-input"
                                                checked={field.value} onChange={field.onChange} />
                                            <label className="custom-control-label" htmlFor={`${name}.${index}.unique`}>&nbsp;</label>
                                        </div>
                                    )}
                                </FastField>
                            </td>
                            <td>
                                <div className="d-flex justify-content-center">
                                    <div className="flex-column">
                                        <MinusButton remove={remove} index={index} />
                                    </div>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="4" className="pl-0">
                            <PlusButton onClick={addItem}>
                                <FormattedMessage {...messages.surveys.form.label.paramQs.add} />
                            </PlusButton>
                        </td>
                    </tr>
                </tfoot>
            </table>);
    } else {
        return (
            <PlusButton onClick={addItem}>
                <FormattedMessage {...messages.surveys.form.label.paramQs.add} />
            </PlusButton>);
    }
};

export default SurveyParametersType;
